function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGunAk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512.001 512.001",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#666666"
    },
    points: "219.934,324.294 173.759,370.483 142.976,339.7 132.522,350.155 163.304,380.938  133.162,411.066 143.615,421.523 178.987,386.165 230.39,334.748  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#666666"
    },
    d: "M440.942,15.575l-11.626-11.64l-13.433,13.433l2.04,21.225l-65.297,65.297l-21.059-9.017 c-2.779-1.19-6.001-0.569-8.137,1.569l-85.687,85.702l10.456,10.454l82.149-82.163l11.017,4.718l-94.716,94.715l13.591,13.591 L470.108,13.59L456.518,0L440.942,15.575z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#808080"
    },
    d: "M379.899,331.177l9.306,53.779c0.634,3.664-1.731,7.181-5.363,7.979 c-59.9,13.164-124.201,1.567-176.398-34.763c-10.719-7.467-20.936-15.968-30.487-25.534l6.454-30.234l41.954-18.172 c39.605,39.619,95.258,53.409,146.042,41.394C375.321,324.7,379.213,327.212,379.899,331.177z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#666666"
    },
    d: "M378.45,383.501c-57.386,11.732-117.052-0.385-165.094-33.822 c-8.848-6.164-23.434-19.197-31.252-26.627l10.314-13.27l18.174-27.241l2.137,2.366c26.656,29.507,62.829,49.1,102.29,54 c18.218,2.263,36.902,1.519,55.294-2.424L378.45,383.501z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCBB29"
    },
    d: "M155.962,411.267l21.623,74.691c2.13,7.36-1.571,15.152-8.623,18.149l-15.729,6.684 c-7.714,3.278-16.623-0.333-19.878-8.056l-17.669-41.922c-3.755-8.886-10.675-16.071-19.428-20.138l-18.674-8.664l11.209-38.127 l38.351-11.433L155.962,411.267z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D39A29"
    },
    d: "M166.426,493.563c-0.431,0.431-0.941,0.774-1.513,1.017l-15.729,6.684 c-1.593,0.677-2.987,0.31-3.675,0.031c-0.689-0.279-1.945-0.985-2.618-2.58l-17.669-41.922 c-4.774-11.297-13.511-20.352-24.604-25.504L78.34,421.067l18.798-18.87l18.901-16.215l30.723,30.723l20.883,72.132 C168.13,490.515,167.664,492.327,166.426,493.563z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCBB29"
    },
    d: "M290.286,199.335l-59.54,59.54l-42.762-6.784l4.335-31.642l59.54-59.54 c3.23-3.23,8.465-3.23,11.694,0l26.732,26.732C293.515,190.87,293.515,196.106,290.286,199.335z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D39A29"
    },
    d: "M283.229,192.278l-59.54,59.54l-34.908-5.538l-0.796,5.811l42.762,6.784l59.54-59.54 c3.229-3.23,3.229-8.466,0-11.694l-7.057-7.057C286.458,183.813,286.458,189.048,283.229,192.278z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4D4D4D"
    },
    d: "M176.956,332.639l-25.741,25.756l-24.071,24.055l-49.56,49.56l-4.687-4.687l-31.005-31.019v-19.88 c0-3.545,1.408-6.944,3.914-9.45l146.511-146.525l0.769,0.769l37.658,37.658l-5.382,25.356L176.956,332.639z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#808080"
    },
    d: "M117.641,352.188l-0.001,0.001l-21.423,21.409c-2.599,2.598-6.812,2.596-9.41-0.003 c-2.597-2.599-2.596-6.811,0.001-9.407l0.001-0.001l21.425-21.409c2.599-2.598,6.812-2.596,9.41,0.003 C120.24,345.379,120.239,349.591,117.641,352.188z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGunAk);
export default __webpack_public_path__ + "static/media/gun-ak.12e3016af263417769f4b23183dd7da5.svg";
export { ForwardRef as ReactComponent };